import { TimelineMax } from 'gsap';
import slick from 'slick-carousel';
import smoothScroll from './lib/scroll-to';
import './lib/bootstrap.bundle'

let lastScrollTop = 0;
const toTopButton = document.getElementById("to-top");

function toTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}

$(window).scroll(function () {
   const st = $(this).scrollTop();
   const $header = $('.layout__header');

   if($header){
       if($(window).scrollTop() > 10){
           $('.layout__header').addClass('is-fixed');
       } else {
           $('.layout__header').removeClass('is-fixed');
       }
        if(!$(window).width() > 1024){
            if (st > lastScrollTop){
                $('.layout__header').removeClass('is-fixed');
            } else if(st <= lastScrollTop) {
                if($(window).scrollTop() > 100){
                    $('.layout__header').addClass('is-fixed');
                } else {
                    $('.layout__header').removeClass('is-fixed');
                }
            }
            lastScrollTop = st;
        }
   }

    if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
        toTopButton.style.display = "block";
    } else {
        toTopButton.style.display = "none";
    }
});


let mobMenu = false;
if($(window).width() < 1200){
    mobMenu = true;
}

// menu animation
const nav = {
    elem: {
        wrapper: $('.main-menu__wrapper'),
        bg: $('.main-menu__bg'),
        header: $('.main-menu__header'),
        items: $('.main-menu__body .menu-item'),
    },
    leave(){
        const tl = new TimelineMax();
        if(nav.elem.wrapper.length > 0 && mobMenu === true){
            tl
            .staggerFromTo(nav.elem.items, .4,
                {
                    opacity: 1
                },
                {
                    opacity: 0
                },
                0.1
            )

            .fromTo(nav.elem.header, .4,
                {
                    opacity: 1
                },
                {
                    opacity: 0
                },
            .4)
            .fromTo(nav.elem.bg, 0.7,
                {
                    transformOrigin: "50% 100%",
                    scaleY: 1,
                    opacity: 1
                },
                {
                    scaleY: 0,
                    opacity: 0,
                    onComplete(){
                        $('body').removeClass('menu-open');
                    }
                },
            .5)
            .fromTo(nav.elem.wrapper, .7,
                {
                    transformOrigin: "50% 100%",
                    scaleY: 1,
                    opacity: 1
                },
                {
                    scaleY: 0,
                    opacity: 0
                },
            0.7)
        } else {
            $('body').removeClass('menu-open');
        }
    },
    enter(){
        const tle = new TimelineMax();
        if(nav.elem.wrapper.length > 0 && mobMenu === true){
            tle
            .fromTo(nav.elem.wrapper, .4,
                {
                    transformOrigin: "50% 100%",
                    scaleY: 0,
                    opacity: 0
                },
                {
                    scaleY: 1,
                    opacity: 1
                }
            ,)
            .fromTo(nav.elem.bg, .4,
                {
                    transformOrigin: "50% 100%",
                    scaleY: 0,
                    opacity: 0
                },
                {
                    scaleY: 1,
                    opacity: 1
                },
             .2)
            .fromTo(nav.elem.header, .7,
                {
                    opacity: 0
                },
                {
                    opacity: 1
                },
             .5)
            .staggerFromTo(nav.elem.items, .7,
                {
                    y: '1.5em',
                    opacity: 0
                },
                {
                    y: 0,
                    opacity: 1
                },
                0.1, .7
            )
        }
    }
}



$(document).on('click', '.menu-trigger', function(){
    $('body').addClass('menu-open');
    nav.enter();
});
$(document).on('click', '.main-menu__wrapper .close-menu', function(){
    nav.leave();
});
$(document).on('click', '.menu-item', function(){
    nav.leave();
});




$('.js-visible-books, .js-visible-games').on('click', function(){
    const parent = $(this).closest('.books__list');
    const tl = new TimelineMax();
    const $hBooks = $('.js-animate', parent);
    tl.staggerTo($hBooks, 1, {height: '100%', width: '100%', opacity: 1, marginBottom: '1rem'}, .15);
    $(this).addClass('hidden');
})

// function setToVisible(){
//     const tl = new TimelineMax();
//     tl.staggerTo($hBooks, .2, {display: 'none'}, 0.1);
//     console.log('test');
// }


const $sliderGame = $('#sliderGame');
$sliderGame.slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    appendArrows: '.apps__slider',
    nextArrow: `<button class="slick-arrow arrow_next"> <svg class="icon icon-arrow-right"><use xlink:href="${window.mediapath}assets/img/sprite.svg#icon-arrow-right"></use></svg></button>`,
    prevArrow: `<button class="slick-arrow arrow_prev"> <svg class="icon icon-arrow-left"><use xlink:href="${window.mediapath}assets/img/sprite.svg#icon-arrow-left"></use></svg></button>`,
    responsive: [
        {
        breakpoint: 1024,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
        }
        }
    ]
});


const $sliderReview = $('#sliderReview');
$sliderReview.slick({
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    infinite: true,
    dots: true,
    arrows: true,
    initialSlide: 1,
    appendDots: '.review',
    appendArrows: '.review__slider',
    nextArrow: `<button class="slick-arrow arrow_next"> <svg class="icon icon-arrow-right"><use xlink:href="${window.mediapath}assets/img/sprite.svg#icon-arrow-right"></use></svg></button>`,
    prevArrow: `<button class="slick-arrow arrow_prev"> <svg class="icon icon-arrow-left"><use xlink:href="${window.mediapath}assets/img/sprite.svg#icon-arrow-left"></use></svg></button>`,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                centerMode: false
            }
        }
    ]
});

$(document).ready(function(){
    nav.leave();

    smoothScroll();

    let isTouch = false;

    if ('ontouchstart' in document.documentElement) {
        isTouch = true;
    }

    document.body.className += isTouch ? ' touch' : ' no-touch';

    toTopButton.onclick = function () {
        $('html, body').animate({
            scrollTop: 0
        }, 500);
    }
});
